
import { ChevronLeft } from 'lucide-react';

type SectionHeaderProps = {
  title: string;
  sectionIcon?: React.ReactNode;
  iconSrc?: string; // Keep for backwards compatibility for now, but mark optional
  buttonText?: string;
  onButtonClick?: () => void;
  icon?: React.ReactNode | null;
  isAdmin?: boolean | null;
  onBack?: () => void;
  subtitle?: string;
  headerActions?: React.ReactNode;
}

const SectionHeader = ({ title, subtitle, sectionIcon, iconSrc, buttonText, icon, onButtonClick, isAdmin, onBack, headerActions }: SectionHeaderProps) => {
  return (
    <>
      <div className=' px-4 py-3 flex  justify-between items-center border-b border-[#E9EAEB]'>
        <div className='  flex items-center align-center gap-2'>
          {onBack && (
            <button
              onClick={onBack}
              className="lg:hidden flex items-center justify-center p-1 hover:bg-gray-100 rounded-md transition-colors mr-1"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
          )}
          <div className='p-1 border border-[#E9EAEB] rounded-[4px]'>
            {sectionIcon ? sectionIcon : (iconSrc ? <img src={iconSrc} className='w-3 h-3' alt='Section Icon' /> : null)}
          </div>
          <div className="flex flex-col">
            <div className='text-body2'>{title}</div>
            {subtitle && <div className="text-[10px] text-muted-foreground leading-none lg:hidden">{subtitle}</div>}
          </div>
        </div>
        <div className='flex items-center gap-2'>
          {headerActions}
          {buttonText && isAdmin && (
            <button
              onClick={onButtonClick}
              className="font-semibold text-lg flex items-center justify-center gap-1 rounded border border-transparent bg-gradient-to-b from-white/10 to-white/0 px-2 py-1 shadow-[0_0_0_0.35px_rgba(22,17,17,0.12),0_0.71px_1.77px_rgba(22,17,17,0.24)] transition-colors hover:bg-gray-100 cursor-pointer"
            >
              {icon} <span className="text-[10px] font-medium text-black">{buttonText}</span>
            </button>
          )}
        </div>
      </div>
    </>
  )
}

export default SectionHeader